import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import api from "../services/api";
import { useAuth } from "../context/AuthContext";
import "../styles/AdminLogin.css";

function AdminLogin() {

  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const response = await api.post(
        "/admin/login",
        {
          email,
          password
        }
      );

      login(response.data.access_token);

      await Swal.fire({
        icon: "success",
        title: "Login Successful",
        text: "Welcome back!",
        timer: 1800,
        showConfirmButton: false
      });

      navigate("/dashboard");

    } catch (err) {

      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text:
          err.response?.data?.message ||
          "Invalid email or password."
      });

    }

  };

  return (

    <div className="login-container">

      <div className="login-card">

        <img
          src="/comp exams.jpeg"
          alt="CompExams Logo"
          className="login-logo"
        />

        <h1>CompExams</h1>

        <h2>Admin Login</h2>

        <form onSubmit={handleSubmit}>

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) =>
              setEmail(e.target.value)
            }
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) =>
              setPassword(e.target.value)
            }
            required
          />

          <button type="submit">
            Login
          </button>

        </form>

      </div>

    </div>

  );

}

export default AdminLogin;